import React, { useEffect, useState } from 'react'
import '../../components/tableComponents/tables.css'
import TableRow from './TableRow'
import NewTableRow from './NewTableRow'
import axiosInstance from '../../../../util/axios'
import styled from 'styled-components'
import { ArrowDownAZ, ArrowDownUp, ArrowUpZA } from 'lucide-react'

const SortButton = styled.button`
	background: none;
	border: none;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	vertical-align: middle;
	padding: 0;
	margin-left: 8px;
	line-height: 0;
	cursor: pointer;
	&:hover {
		color: #007bff;
	}
`
const HeaderContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: 5px;
`
const UpperRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`

const Subtitle = styled.span`
	font-size: 0.8rem;
	font-weight: normal;
	color: #666;
	margin-top: 0px;
`
const UserTable = styled.table`
	width: 100%;
	border-collapse: collapse;
`
const StyledTableRow = styled.tr`
	border-bottom: 1px solid #000000;
	height: 32px;
`
const StyledTableHeader = styled.th`
	text-align: start;
	vertical-align: top;
	&:first-child {
		padding-top: 3.9px;
	}
`

export default function UsersTable({ data, setData }) {
	const [groups, setGroups] = useState([])
	const [nameSortDirection, setNameSortDirection] = useState(null) // null | 'asc' | 'desc'

	const sortedData = [...(data || [])].sort((a, b) => {
		if (!a.id && !b.id) return 0
		if (!a.id) return 1
		if (!b.id) return -1

		if (!nameSortDirection) return 0

		const aa = (a.username || '').toString()
		const bb = (b.username || '').toString()
		const cmp = aa.localeCompare(bb, undefined, { sensitivity: 'base' })

		return nameSortDirection === 'asc' ? cmp : -cmp
	})

	const toggleSortByName = () => {
		setNameSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'))
	}

	const deleteUser = (userId) => {
		setData((state) => state.filter((e) => e.id !== userId))
	}

	const updateDataElement = (targetElement, updatedData) => {
		const newData = data.map((item) => {
			const isMatch = item.id
				? item.id === targetElement.id
				: item.tempId === targetElement.tempId

			return isMatch ? updatedData : item
		})

		setData(newData)
	}

	useEffect(() => {
		axiosInstance.get('/api/groups').then((groupList) => {
			setGroups(groupList['hydra:member'])
		})
	}, [])

	return (
		<UserTable>
			<thead>
				<StyledTableRow>
					<StyledTableHeader>Lfd. Nr.</StyledTableHeader>
					<StyledTableHeader>
						<HeaderContent>
							<UpperRow>
								<span>Name, Vorname</span>
								<SortButton
									className='sortByNameBtn'
									type='button'
									onClick={toggleSortByName}
									aria-label='Sortiere nach Name'
								>
									{!nameSortDirection ? (
										<ArrowDownUp size={18} strokeWidth={3} />
									) : nameSortDirection === 'asc' ? (
										<ArrowDownAZ size={18} strokeWidth={2.7} />
									) : (
										<ArrowUpZA size={18} strokeWidth={2.7} />
									)}
								</SortButton>
							</UpperRow>
							<Subtitle>(Eingabe/Anzeige max. 40 Zeichen)</Subtitle>
						</HeaderContent>
					</StyledTableHeader>
					<StyledTableHeader>
						E-Mail-Adresse <br />
						<Subtitle>(Eingabe unbegrenzt, Anzeige max. 50 Zeichen)</Subtitle>
					</StyledTableHeader>

					<StyledTableHeader>
						Telefonnummer <br />
						<Subtitle> (optional)</Subtitle>
					</StyledTableHeader>
					<StyledTableHeader>Nutzergruppe</StyledTableHeader>
				</StyledTableRow>
			</thead>
			<tbody>
				{sortedData.map((value, index) =>
					!!value.id ? (
						<TableRow
							key={value.id}
							dataElement={value}
							index={index}
							setDataElement={(updatedValue) =>
								updateDataElement(value, updatedValue)
							}
							deleteElement={() => deleteUser(value.id)}
							groups={groups}
						/>
					) : (
						<NewTableRow
							key={value.id || value.tempId}
							dataElement={value}
							setDataElement={(updatedValue) =>
								updateDataElement(value, updatedValue)
							}
							groups={groups}
						/>
					)
				)}
			</tbody>
		</UserTable>
	)
}
